<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <loading v-if="! showContent"></loading>
                <h2 class="titulo" v-if="showContent">   {{ title }}</h2>
                <div class="baixar_aplicativo" v-if="showContent">
                    <loading v-if="! showContent"></loading>
                    <a :href="urlAndroid" target="_blank" v-show="showUrl(urlAndroid)">
                        <img src="static/images/download_app_android.png">
                    </a>
                    <a :href="urlIos" target="_blank" v-show="showUrl(urlIos)">
                        <img src="static/images/download_app_ios.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import { get } from '../../helpers/api';
    import Loading from '../common/Loading.vue';

    export default {
        components: {
            Loading
        },
        props: ['bloco'],
        data() {
            return {
                title: 'Baixe o aplicativo',
                showContent: false,
                urlAndroid: '',
                urlIos: ''
            }
        },
        created() {
            if (this.bloco.nome) {
                this.title = this.bloco.nome;
            }
            let self = this;
            get('content/'+this.bloco.id).then(function (response) {
                self.showContent = true;
                self.urlAndroid = response.data.result.data.urlAndroid;
                self.urlIos = response.data.result.data.urlIos;
            });
        },
        methods: {
            showUrl(url) {
                return url !== '';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/home/DownloadApp.vue